import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  NOTIFICATION_ACTION_TABS,
  NOTIFICATION_INFO_TABS,
  NOTIFICATION_PAGE_SIZES,
  NOTIFICATION_STEPS,
} from 'utils/Constants';

// focus : colonne choisie en dernier via les cartes résumé ('actions' | 'infos'),
// pour qu'une seule carte soit sélectionnée à la fois.
const DEFAULTS = { tab: 'todo', info: 'unread', step: 'all', q: '', focus: 'actions' };
const FOCUS_VALUES = ['actions', 'infos'];
const STEP_IDS = NOTIFICATION_STEPS.map((s) => s.id);

/**
 * Filtres et onglets de la page Notifications stockés dans l'URL
 * (ex. ?tab=urgent&step=sourcing&q=bip&info=all), pour qu'ils
 * survivent au rafraîchissement et au partage du lien.
 */
export function useNotificationFilters() {
  const location = useLocation();
  const history = useHistory();

  const filters = useMemo(() => {
    const p = new URLSearchParams(location.search);
    const tab = p.get('tab');
    const info = p.get('info');
    const step = p.get('step');
    const size = Number(p.get('size'));
    const focus = p.get('focus');
    return {
      focus: FOCUS_VALUES.includes(focus) ? focus : DEFAULTS.focus,
      tab: NOTIFICATION_ACTION_TABS.includes(tab) ? tab : DEFAULTS.tab,
      info: NOTIFICATION_INFO_TABS.includes(info) ? info : DEFAULTS.info,
      step: STEP_IDS.includes(step) ? step : DEFAULTS.step,
      q: p.get('q') || DEFAULTS.q,
      size: NOTIFICATION_PAGE_SIZES.includes(size) ? size : NOTIFICATION_PAGE_SIZES[0],
    };
  }, [location.search]);

  const setFilters = useCallback(
    (patch) => {
      const p = new URLSearchParams(location.search);
      Object.entries(patch).forEach(([k, v]) => {
        if (v === undefined || v === null || v === '' || v === DEFAULTS[k]) p.delete(k);
        else p.set(k, String(v));
      });
      const qs = p.toString();
      history.replace({ pathname: location.pathname, search: qs ? `?${qs}` : '' });
    },
    [history, location.pathname, location.search]
  );

  const resetFilters = useCallback(() => setFilters({ step: null, q: null }), [setFilters]);

  const filtersActive = filters.step !== 'all' || !!filters.q;

  return { filters, setFilters, resetFilters, filtersActive };
}
